import React from 'react';

interface VaiuLogoProps {
  variant?: 'default' | 'white' | 'icon' | 'wordmark';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showTagline?: boolean;
}

const VaiuLogo: React.FC<VaiuLogoProps> = ({ 
  variant = 'default', 
  size = 'md', 
  className = '',
  showTagline = true
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return { container: 'h-12', icon: 'w-10 h-10', text: 'text-lg', tagline: 'text-xs', subtitle: 'text-xs' };
      case 'md':
        return { container: 'h-16', icon: 'w-14 h-14', text: 'text-xl', tagline: 'text-sm', subtitle: 'text-sm' };
      case 'lg':
        return { container: 'h-20', icon: 'w-18 h-18', text: 'text-3xl', tagline: 'text-base', subtitle: 'text-base' };
      case 'xl':
        return { container: 'h-24', icon: 'w-20 h-20', text: 'text-4xl', tagline: 'text-lg', subtitle: 'text-lg' };
      default:
        return { container: 'h-16', icon: 'w-14 h-14', text: 'text-xl', tagline: 'text-sm', subtitle: 'text-sm' };
    }
  };

  const sizeClasses = getSizeClasses();
  const isWhite = variant === 'white';

  // Logo with tokenized pay branding
  const VaiuNetworkLogo = () => (
    <div className={`${sizeClasses.icon} relative flex items-center justify-center`}>
      <img 
        src="/img/logo.png"
        alt="Vaiu - Tokenized Pay"
        className="w-full h-full object-contain"
      />
    </div>
  );

  // Icon only variant
  if (variant === 'icon') {
    return (
      <div className={className}>
        <VaiuNetworkLogo />
      </div>
    );
  }

  // Wordmark variant (logo only for Vaiu brand)
  if (variant === 'wordmark') {
    return (
      <div className={`flex flex-col items-center space-y-1 ${className}`}>
        <div className={`${sizeClasses.container} relative flex items-center justify-center`}>
          <img 
            src="/img/logo.png"
            alt="Vaiu - Tokenized Pay"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    );
  }

  // Default variant (logo only for Vaiu brand)
  return (
    <div className={`${sizeClasses.container} ${className}`}>
      <VaiuNetworkLogo />
    </div>
  );
};

export default VaiuLogo; 